export default __webpack_public_path__ + "minus-circle.svg";